import {validateBucketLeaveReason} from './MembersValidation'

export type ValidationLeaveBucketInput = {
  bucketLeaveReason: string
}

export type ValidationLeaveBucketResultDetail = {
  [K in keyof ValidationLeaveBucketInput]: string[]
}

export type ValidationLeaveBucketResult = {
  hasError: boolean
  errors: ValidationLeaveBucketResultDetail
}

export const validateMemberLeaveBucketInput = (
  input: ValidationLeaveBucketInput,
): ValidationLeaveBucketResult => {

  const details: ValidationLeaveBucketResultDetail = {
    bucketLeaveReason: validateBucketLeaveReason(input.bucketLeaveReason),
  }

  const hasError =
    Object.values(details)
      .map(errorArray => errorArray.length)
      .some(length => length > 0)

  return {
    hasError: hasError,
    errors: details,
  }
}
